import { InjectionToken } from '@angular/core'

/**
 * Chaves de APIs externas resolvidas em tempo de boot, fora do bundle e do repositório.
 *
 * Em stg/prd o arquivo é gerado por um Lambda@Edge a partir do secret
 * `/stg|prd/portal-compras-publica-infra/secrets` (ver `infra/`); em desenvolvimento vem de
 * `src/config/runtime-config.json`, que não é versionado (modelo em `runtime-config.example.json`).
 */
export interface RuntimeConfig {
    recaptcha_key: string
}

export const RUNTIME_CONFIG = new InjectionToken<RuntimeConfig>('RUNTIME_CONFIG')

export const RUNTIME_CONFIG_URL = '/runtime-config.json'

export const EMPTY_RUNTIME_CONFIG: RuntimeConfig = {
    recaptcha_key: ''
}

const REQUEST_TIMEOUT_MS = 8000

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS)

    try {
        const response = await fetch(RUNTIME_CONFIG_URL, { signal: controller.signal })
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return normalize(await response.json())
    } catch (error) {
        // O SPA sobe mesmo sem as chaves: o reCAPTCHA não é carregado e as requisições protegidas
        // seguem sem token, mas o restante da aplicação continua acessível.
        console.error('Não foi possível carregar o runtime config', error)
        return { ...EMPTY_RUNTIME_CONFIG }
    } finally {
        clearTimeout(timeout)
    }
}

function normalize(payload: unknown): RuntimeConfig {
    const source = (payload ?? {}) as Partial<Record<keyof RuntimeConfig, unknown>>
    return {
        recaptcha_key: asString(source.recaptcha_key)
    }
}

function asString(value: unknown): string {
    return typeof value === 'string' ? value : ''
}
